import { createSignal } from '@react-rxjs/utils'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'

import { Checkbox } from '../../../form/Checkbox'
import * as Styled from './styled'

const [setTestKitPaymentAgreementHighlight$, setTestKitPaymentAgreementHighlight] =
  createSignal<Record<string, never>>()

export const tickTestKitPaymentAgreementHighlight: () => void = () =>
  setTestKitPaymentAgreementHighlight({})

interface TestKitPaymentAgreementProps {
  isDisabled: boolean
}

export const TestKitPaymentAgreement: React.FC<TestKitPaymentAgreementProps> = ({ isDisabled }) => {
  const [agreementHighlight, setAgreementHighlight] = useState<0 | 1 | null>(null)

  useEffect(() => {
    const subscription = setTestKitPaymentAgreementHighlight$.subscribe(() => {
      setAgreementHighlight((prevState) => (prevState ? 0 : 1))
    })
    return () => subscription.unsubscribe()
  }, [])

  const { errors } = useFormContext()

  useEffect(() => {
    const error = errors['testKitPaymentAgree']
    if (error) {
      tickTestKitPaymentAgreementHighlight()
    }
  }, [errors])

  return (
    <Styled.Form $highlight={agreementHighlight}>
      <Checkbox
        disabled={isDisabled}
        label={
          <Styled.Text>
            I agree that DFH may charge my on file payment method for the full cost of the Spotlight
            test once it has been processed by DSL.
          </Styled.Text>
        }
        name="testKitPaymentAgree"
      />
    </Styled.Form>
  )
}
